import { InputEdit } from "components";
import { useState } from "react";
import { Button, Col, Container, Form, FormLabel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useUsersApi, useAuth } from "utils/hooks";

import { validateEmail } from "utils/helpers/validators";

import "./ForgotPassword.css";

import { COLORS } from "utils/colors";

export function ForgotPassword() {
  const api = useUsersApi();
  const { onLogout } =
      useAuth();
  const navigate = useNavigate();
  const [emailAddress, setEmailAddress] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [isValidated, setValidated] = useState(false);
  const [isCompleted, setCompleted] = useState(false);

  function ErrorMessage({ message }) {
    return message ? (
      <Form.Group className="m-3">
        <h4 className="text-danger text-center">{message}</h4>
        <p className="text-center">
          <a href="/login" className="text-primary">
            Go to Login Page
          </a>
        </p>
      </Form.Group>
    ) : null;
  }

  function SuccessMessage({ message }) {
    return message ? (
      <Form.Group className="m-3">
        <h5 className="text-success text-center">{message}</h5>
        <p className="text-center">
          <a href="/login" className="text-primary">
            Go to Login Page
          </a>
        </p>
      </Form.Group>
    ) : null;
  }

  function recoverPasswordForm() {
    return (
      <>
        <Form.Group className="mt-4 ms-2 me-2" style={{ opacity: 1 }}>
          <FormLabel style={{ color: COLORS.greyFontColor }}>
            Enter your email address and we'll send you a link to reset your
            password
          </FormLabel>
        </Form.Group>
        <Form.Group style={{ opacity: 1 }}>
          <InputEdit
            placeholder={"Email address"}
            error={errorMessage}
            onBlur={(e) => {
              if (e.target.value === null || e.target.value === "") {
                setErrorMessage("Email address cannot be empty");
                setValidated(false);
                return;
              }
              !validateEmail(e.target.value) &&
                (setErrorMessage("Email address invalid format"),
                setValidated(false));
            }}
            onFocus={(e) => {
              setErrorMessage(null);
            }}
            onChange={(e) => {
              setErrorMessage(null);
              setEmailAddress(e.target.value);
              validateEmail(e.target.value)
                ? setValidated(true)
                : setValidated(false);
            }}
          />
        </Form.Group>

        <Form.Group className="mb-0 mt-1" style={{ opacity: 1 }}>
          <p style={{ color: "red" }} className="m-0 p-0">
            {errorMessage || "\u00A0"}
          </p>
        </Form.Group>

        <Form.Group className="mt-4 ms-2 me-2 text-center">
          <Button
            type="submit"
            lg={8}
            disabled={!isValidated}
            className="btn btn-primary mt-3"
            onClick={async (e) => {
              e.preventDefault();

              const result = await api.recoverPassword(emailAddress);
              onLogout()

              setCompleted(true);
            }}
          >
            Send link to email
          </Button>
        </Form.Group>
      </>
    );
  }

  return (
    <div className="classy-subtle-dark-gray-gradient">
      <Container>
        <Container className="d-flex align-items-center justify-content-center vh-100 login-container login-component-fadein">
          <Col md={4}>
            <Form className="shadow  login-form" style={{ opacity: 0.9 }}>
              <Form.Group className="text-center">
                <img
                  src="/logo/logo.png"
                  width={200}
                  className="rounded img-responsive"
                  alt="ECHO Platform"
                />
              </Form.Group>
              {!isCompleted && recoverPasswordForm()}
              {isCompleted && (
                <SuccessMessage
                  message={`If account is found an email with a recovery link will be sent to ${emailAddress}`}
                />
              )}
            </Form>
          </Col>
        </Container>
      </Container>
    </div>
  );
}
